import putV1StockAutoOrderResume from '@services/api/stock/order/auto/resume';
import { useMutation } from '@tanstack/react-query';

/**
 * @param {number} id
 */
function useResumeAutoOrder(id) {
  const { cb, key } = putV1StockAutoOrderResume(id);
  const { mutateAsync } = useMutation({
    mutationKey: key,
    mutationFn: cb,
  });

  return mutateAsync;
}

export default useResumeAutoOrder;
